import { render, staticRenderFns } from "./userAnalysis.vue?vue&type=template&id=1780d6df&scoped=true"
import script from "./userAnalysis.vue?vue&type=script&lang=ts"
export * from "./userAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./userAnalysis.vue?vue&type=style&index=0&id=1780d6df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780d6df",
  null
  
)

export default component.exports